// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import * as amplitude from '@amplitude/analytics-browser';
import environment from '../../config/environment';

const dumpMode = false;
const blockedUserEmails = ["arun.prem@teganalytics.com", "lobby.heartbeat@healthworksai.com", "arun.prem@teganalytics.com"];
const internalUsersRegex = /healthworksai.com|teganalytics.com/;  // healthworksai.com and teganalytics.com
const internalUsers = ["vibhore.goel@brighthealth.com"]

/**
 * Initializes the Amplitude analytics with the appropriate API key based on user permissions and environment.
 *
 * @param {string} [userPermission="HWAI_USER"] - The permission level of the user.
 * @param {string} [userEmail=undefined] - The email of the user for determining if they are internal or blocked.
 * 
 * The function determines whether to use the production API key or a default one based on the following conditions:
 *   - The environment is "PROD"
 *   - The user permission is "USER"
 *   - The user email is not from an internal domain or listed as blocked
 *   - Dump mode is not active
 * 
 * Amplitude is initialized with specific autocapture settings, which differ if dump mode is enabled.
 */
const initAmplitude = async (userPermission = "HWAI_USER", userEmail = undefined) => {
    const isProd = environment === "PROD" && userPermission === "USER" && !internalUsersRegex.test(userEmail) && !internalUsers.includes(userEmail) && !blockedUserEmails.includes(userEmail) && !dumpMode;
    // const apiKey = blockedUserEmails.includes(userEmail) ? process.env.REACT_APP_AMPLITUDE_API_KEY : dumpMode ? process.env.REACT_APP_AMPLITUDE_API_KEY : userPermission === "USER" && environment === "PROD" ? process.env.REACT_APP_AMPLITUDE_PROD_API_KEY : process.env.REACT_APP_AMPLITUDE_API_KEY;
    const apiKey = isProd ? process.env.REACT_APP_AMPLITUDE_PROD_API_KEY : process.env.REACT_APP_AMPLITUDE_API_KEY;
    await amplitude.init(apiKey, {
        autocapture: {
            ...dumpMode ? {
                attribution: true,
                elementInteractions: true,
                pageViews: true,
                fileDownloads: true,
                formInteractions: true,
            } : {
                pageViews: false,
            }
        },
        sessionTimeout: 2 * 60 * 60 * 1000, // 2 hour
    }).promise.then(() => {
        amplitude.flush()
    })
};

export default amplitude;
export { initAmplitude };


